import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import PeopleIcon from "@mui/icons-material/People";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import GroupsIcon from "@mui/icons-material/Groups";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import LineCharts from "../../../Components/ReactChart/LineCharts";
import Avatar from "@mui/material/Avatar";
import ImageIcon from "@mui/icons-material/Image";
import WorkIcon from "@mui/icons-material/Work";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import CountUp from "react-countup";
import { getData, getTotalVisitors } from "../../../Config/FirebaseMethod";

const Home = () => {
  let [stdData, setStdData] = useState([]);
  const [isLoading, setisLoading] = useState(true);
  const [totalVisitors, setTotalVisitors] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const theme = useTheme();
  const color = theme.palette.mode === "light" ? "#FFFFFF" : "#212121";
  const [patientCount, setPatientCount] = useState(0);
  const [feedbacks, setFeedbacks] = useState(0);
  const [Apt, setApt] = useState(0);
  const [Contact, setContact] = useState(0);
  const [request, setReq] = useState(0);
  const [patient, setPatientData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const sendStdData = () => {
    setisLoading(true);
    getData(`AneeqUllahKhan/`)
      .then((res) => {
        setisLoading(false);
        setStdData(res);

        const patientCount = res.filter(
          (obj) => obj.category === "Admin"
        ).length;
        setPatientCount(patientCount);
      })
      .catch((err) => {
        setisLoading(false);
        alert(err);
      });
  };

  const TotalFeedback = () => {
    setisLoading(true);
    getData(`Feedback/`)
      .then((res) => {
        setisLoading(false);
        setStdData(res);

        let totalFeedbacks = res.length;
        setFeedbacks(totalFeedbacks);
      })
      .catch((err) => {
        setisLoading(false);
        alert(err);
      });
  };

  const TotalApt = () => {
    setisLoading(true);
    getData(`Booking/`)
      .then((res) => {
        setisLoading(false);
        setStdData(res);
        setPatientData(res);
        let totalFeedbacks = res.length;
        setApt(totalFeedbacks);
      })
      .catch((err) => {
        setisLoading(false);
        alert(err);
      });
  };

  const TotalContact = () => {
    setisLoading(true);
    getData(`Contact/`)
      .then((res) => {
        setisLoading(false);
        setStdData(res);

        let totalFeedbacks = res.length;
        setContact(totalFeedbacks);
      })
      .catch((err) => {
        setisLoading(false);
        alert(err);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const displayedData = patient.slice(startIndex, endIndex);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Call the real-time function
        await sendStdData();
        TotalFeedback();
        TotalApt();
        TotalContact();

        const totalCount = await getTotalVisitors();
        setTotalVisitors(totalCount);
      } catch (err) {
        // Handle any errors
        console.error(err);
      }
    };

    // Run the function initially
    fetchData();

    // Set up an interval to run the function periodically
    const interval = setInterval(fetchData, 2000); // Fetch data every 2 seconds

    // Clean up the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <Box>
              <Stack direction="row" spacing={2}>
                <Card sx={{ minWidth: 32 + "%", height: 150, borderRadius: 3 }}>
                  <CardContent>
                    <div
                      className="icon-styling"
                      style={{ backgroundColor: "#e3b984" }}
                    >
                      <GroupsIcon />
                    </div>
                    <Typography gutterBottom variant="h5" component="div">
                      <CountUp delay={0.2} end={patientCount} duration={0.3} />
                    </Typography>
                    <Typography gutterBottom variant="body2" component="div">
                      Total Admins
                    </Typography>
                  </CardContent>
                </Card>
                <Card
                  sx={{
                    minWidth: 32 + "%",
                    height: 150,
                    borderRadius: 3,
                  }}
                >
                  <CardContent>
                    <div
                      className="icon-styling"
                      style={{ backgroundColor: "#a5d37a" }}
                    >
                      <PeopleIcon />
                    </div>
                    <Typography gutterBottom variant="h5" component="div">
                      <CountUp delay={0.2} end={Apt} duration={0.3} />
                    </Typography>
                    <Typography gutterBottom variant="body2" component="div">
                      Total Meetings
                    </Typography>
                  </CardContent>
                </Card>
                <Card
                  sx={{ minWidth: 32 + "%", height: 150, borderRadius: 3 }}
                  bgcolor={color}
                >
                  <CardContent>
                    <div
                      className="icon-styling"
                      style={{ backgroundColor: "#fec90f" }}
                    >
                      <Inventory2Icon />
                    </div>
                    <Typography gutterBottom variant="h5" component="div">
                      <CountUp delay={0.2} end={feedbacks} duration={0.3} />
                    </Typography>
                    <Typography gutterBottom variant="body2" component="div">
                      Total Feedbacks
                    </Typography>
                  </CardContent>
                </Card>
              </Stack>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box>
              <Stack spacing={2}>
                <Card sx={{ maxWidth: 148 + "%" }}>
                  <Stack spacing={2} direction="row">
                    <div
                      className="icon-style"
                      style={{ backgroundColor: "#74C9A4" }}
                    >
                      <AccountBalanceWalletIcon />
                    </div>
                    <div className="dashboard-card-content">
                      <span className="dashboard-card-title">{request}</span>{" "}
                      <br />
                      <span className="dashboard-card-subtitle">
                        Total Requests
                      </span>
                    </div>
                  </Stack>
                </Card>
                <Card sx={{ maxWidth: 148 + "%" }}>
                  <Stack spacing={2} direction="row">
                    <div
                      className="icon-style"
                      style={{ backgroundColor: "#7488c9" }}
                    >
                      <SignalCellularAltIcon />
                    </div>
                    <div className="dashboard-card-content">
                      <span className="dashboard-card-title">{Contact}</span>{" "}
                      <br />
                      <span className="dashboard-card-subtitle">
                        Total Contacts
                      </span>
                    </div>
                  </Stack>
                </Card>
              </Stack>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <Card sx={{ height: 60 + "vh" }}>
              <CardContent>
                <LineCharts />
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={4}>
            <Card sx={{ height: 60 + "vh" }}>
              <CardContent>
                <Typography gutterBottom variant="h6" component="div">
                  Top Products
                </Typography>
                <List
                  sx={{
                    width: "100%",
                    maxWidth: 360,
                  }}
                >
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <ImageIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText secondary="In Testing">
                      Patient Information System
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <WorkIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText secondary="In Development">
                      Appointment System
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <BeachAccessIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText secondary="In Development">
                      AI Health Chatbot
                    </ListItemText>
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card sx={{ height: "auto" }}>
              <CardContent>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>S.ID</TableCell>
                      <TableCell>Full Name</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Contact Number</TableCell>
                      <TableCell>Purpose</TableCell>
                      <TableCell>Social Media</TableCell>
                      <TableCell>Date Time</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {displayedData.map((row, i) => (
                      <TableRow key={i}>
                        <TableCell>{row.id}</TableCell>
                        <TableCell>{row.fullname}</TableCell>
                        <TableCell>{row.email}</TableCell>
                        <TableCell>{row.number}</TableCell>
                        <TableCell>{row.purpose}</TableCell>
                        <TableCell>{row.social}</TableCell>
                        <TableCell>{row.dateTime}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <div className="container mt-2">
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    count={patient.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Home;
